import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { ASSIGN_MANAGE_FORM_NAME } from '../../utils/constants';
import { getStudentsBySections } from '../../utils';
import {
  fetchGroupedAssignments,
  setAssessmentGroup as dispatchSetAssessmentGroup,
} from '../../state/actions';

const mapStateToProps = (state, ownProps) => {
  const { featureFlag } = state;
  const { isAssessmentForm, isResourceForm, isFinalExam } = ownProps;
  const formData = getFormValues(ASSIGN_MANAGE_FORM_NAME)(state) || {
    assignees: [],
    updateAssignees: [],
    allAssignees: [],
    hasDateAndTime: false,
    startsAt: null,
    startsAtPart2: null,
    dueAt: null,
    printToggle: null,
    isSecure: null,
    duration: null,
    hasTimeLimit: false,
    timer: null,
    scoreDisplay: 'no',
    isAssessmentRenamed: false,
    title: '',
    hasScrambledOrder: false,
    studentScoring: false,
    attestationAgreementChecked: false,
    startsAtError: [0],
    partType: null,
    students: [],
    testTakingLocation: null,
    allowLateSubmission: false,
    isSoftTimer: false,
  };
  const { allAssignees } = formData;
  const subjectData = state.subject.data;
  const allAssigneesStudents = getStudentsBySections(
    subjectData.classes || [],
    allAssignees,
  );
  const individualStudentAssignmentFlag =
    (isResourceForm || (isAssessmentForm && !isFinalExam)) &&
    featureFlag.individual_student_assignment;
  const { isPreApSubject } = subjectData;

  return {
    formData,
    assignmentsResponse: state.assignItem.assignments,
    userData: state.userData,
    assessments: (ownProps.assessments || []).length
      ? ownProps.assessments
      : state.assessment.groupedAssignmentsData.resources,
    subject: state.subject.data,
    studentsBySection: state.studentsBySection || {},
    showAttestationFlag: featureFlag.show_attestation_confirmation_dialog,
    // These two are used by child components, even if they're not used here
    // removing these will cause the Lockdown Options to not appear at all.
    secureBrowserFlag: featureFlag.secure_browser,
    secureBrowserPreApFlag: featureFlag.secure_browser_preap,
    manageMultipleClassesFlag: featureFlag.assignment_manage_classes_dropdown,
    individualStudentAssignmentFlag,
    loadingGroupedAssignments: state.assessment.loadingGroupedAssignments,
    allAssigneesStudents,
    isPreApSubject,
    isFinalExam,
    disablePpcAutoAssignFlag: featureFlag.disable_ppc_auto_assign,
  };
};

const reduxConnect = connect(mapStateToProps, {
  setAssessmentGroup: dispatchSetAssessmentGroup,
  fetchOtherAssignments: fetchGroupedAssignments,
});

export default reduxConnect;
